import axios from 'axios'
import ApplicationStepResolver from "../plugins/ApplicationStepResolver";


export default {
  namespaced: true,
  state: {
    assets: {
      alternativeFundingPrograms: [],
      disabled: [],
      disconnectedStatus: [],
      education: [],
      ethnicities: [],
      evictionStatuses: [],
      genders: [],
      healthInsurance: [],
      hhRelations: [],
      householdSize: [],
      languages: [],
      legalStatus: [],
      maritalStatus: [],
      militaryStatus: [],
      personCharacteristic: [],
      races: [],
      states: [],
      counties: [],
      workStatus: [],
      propertyTypes: [],
      unitLedgerEntryTypes: [],
      hardshipReasons: [],
      housingReasons: [],
      landlordTerms: [],
      incomeTypes: [],
      zeroIncomeTypes: [],
      uapHardshipReasons: [],
    },
    application: null,
    applicant: {
      primary_contact: {},
      secondary_contact: {},
      mail_address: {},
      property_address: { property_type_id: null },
    },
    hhMembers: [],
    documentRequests: [],
    documents: [],
    renterManager: {},
    renterOwner: {},
    ownerOrganization: {},
    managerOrganization: {},
    organization: {},
    statuses: [],
    landlordConfirmations: [],
    statusChanges: [],
    programChanges: [],
    householdApplicationActivityLogs: [],
    householdAppSearchResult: [],
    signatures: [],
    project: {
      buildings: [],
      units: [],
    },
    lastStep: null,
    vendorList: [],
    householdApplicationLandlord: null,
    defaultProject: null,
    lmi: null,
    monthInputsByType: {},
  },
  mutations: {
    clear(state) {
      state.application = null;
      state.householdApplicationActivityLogs = []
    },
    setApplicationField(state, { field, value }) {
      state.application[field] = value;
    },
    setLastStep(state, lastStep) {
      state.lastStep = lastStep;
    },
    fetchSuccess(state, { assets, applicant, application, primaryContact, secondaryContact, mailAddress, propertyAddress, hhMembers, renterManager, renterOwner, propertyOwnerOrganization, propertyManagerOrganization, organization, documentRequests, documents, landlordConfirmations, statusChanges, project, signatures, programChanges, activityLogs, defaultProject, lmi, householdApplicationLandlord }) {
      state.assets = assets
      state.application = {
        ...application
      },
      state.applicant = {
        ...applicant,
        primary_contact: primaryContact || {},
        secondary_contact: secondaryContact || {},
        mail_address: mailAddress || {},
        property_address: propertyAddress || { property_type_id: null },
      }
      state.hhMembers = hhMembers || [{}]
      state.renterManager = renterManager
      state.renterOwner = renterOwner
      state.ownerOrganization = propertyOwnerOrganization;
      state.managerOrganization = propertyManagerOrganization;
      state.organization = organization
      state.documentRequests = documentRequests;
      state.documents = documents;
      state.landlordConfirmations = landlordConfirmations;
      state.statusChanges = statusChanges;
      state.programChanges = programChanges;
      state.householdApplicationLandlord = householdApplicationLandlord;
      state.signatures = signatures;
      if(project) {
        state.project = project;
      }
      state.defaultProject = defaultProject;
      state.lmi = lmi;
    },

    fetchLogSuccess(state, { refresh, data }){
      if (data && data.length) {
        if (refresh)
          state.householdApplicationActivityLogs = [];
        state.householdApplicationActivityLogs = [
          ...state.householdApplicationActivityLogs,
          ...data
        ];
      }
    },

    fetchStatusSuccess(state, data)
    {
      state.statuses = data
    },

    createSuccess(state, { assets, applicant, application, primaryContact, secondaryContact, mailAddress, propertyAddress,  hhMembers, renterManager, renterOwner, organization }) {
      state.assets = assets
      state.application = application
      state.applicant = {
        ...applicant,
        primary_contact: primaryContact || {},
        secondary_contact: secondaryContact || {},
        mail_address: mailAddress || {},
        property_address: propertyAddress || {},
      }
      state.hhMembers = hhMembers || [{}]
      state.renterManager = renterManager
      state.organization = organization
    },

    updateSuccess(state, { assets, applicant, application, primaryContact, secondaryContact, mailAddress, propertyAddress,  hhMembers, renterManager, renterOwner, organization }) {
      state.assets = assets
      state.application = application
      state.applicant = {
        ...applicant,
        primary_contact: primaryContact || {},
        secondary_contact: secondaryContact || {},
        mail_address: mailAddress || {},
        property_address: propertyAddress || {},
      }
      state.hhMembers = hhMembers || [{}]
      state.renterManager = renterManager
      state.renterOwner = renterOwner
      state.organization = organization
    },

    addHHMember(state, index) {
      state.hhMembers = [...state.hhMembers, {
        type: 2
      }]
    },

    removeHHMember(state, index) {
      state.hhMembers = state.hhMembers.filter((item, i) => i !== index)
    },

    updateHHMember(state, data) {
      state.hhMembers = data
    },

    addDocument(state, document) {
      state.documents = [...state.documents, document];
    },

    setDocuments(state, docs) {
      state.documents = docs;
    },

    resetMemberSignature(state, {id, key}) {
      const memberIndex = state.application.household.members.findIndex(item => item.id === id)
      if (memberIndex !== -1)
      {
        let sigId = state.application.household.members[memberIndex].signatures.findIndex(item => item.key === key)
        if (sigId !== -1)
        {
          state.application.household.members[memberIndex].signatures.splice(sigId, 1)
        }
      }
    },

    fetchVendorListSuccess(state, vendorList){
      state.vendorList = [...vendorList]
    },

    setFactBasedProxy(state, factBasedProxy) {
      state.application.fact_based_proxy = factBasedProxy;
    },

    setMonthInput(state, payload) {
      let monthInputs = _.cloneDeep(state.monthInputsByType);
      let type = payload.type
      monthInputs[type.id] = {
        type: type,
        data: payload.monthInputs,
      }
      state.monthInputsByType = monthInputs;
    },
  },
  actions: {
    clear({ commit, state }) {
      commit('clear')
    },
    fetch ({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/hope/applications/${id}`)
          .then((res) => {
            res.data.data.activityLogs = res.data.activityLogs;
            commit('fetchSuccess', res.data.data)
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    fetchSplitPaymentLog ({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        let url = `/api/hope/application/${param['id']}/split-payment-logs?q=${param['q']}&count=${param['count']}&nextItems=${param['nextItems']}`;
        axios
          .get(url)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    fetchLandlordConfirmationLog ({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        let url = `/api/hope/application/${param['id']}/landlord-confirmation-logs?q=${param['q']}&count=${param['count']}&nextItems=${param['nextItems']}`;
        axios
          .get(url)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    fetchLandlordLog ({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        let url = `/api/hope/application/${param['id']}/landlord-logs?q=${param['q']}&count=${param['count']}&nextItems=${param['nextItems']}`;
        axios
          .get(url)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    fetchLog ({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        let url = `/api/hope/application/${param['id']}/logs?count=${param['count']}&nextItems=${param['nextItems']}&q=${param['q']}`;
        axios
          .get(url)
          .then((res) => {
            commit('fetchLogSuccess', {
              refresh: param.refresh,
              data: res.data.data
            })
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    fetchStatus ({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/hope/application/${id}/status-list`)
          .then((res) => {
            commit('fetchStatusSuccess', res.data.data)
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    create({ commit, state}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/hope/applications`, data)
          .then((res) => {
            commit('createSuccess', res.data.data)
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    update({ commit, state}, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/hope/applications/${data.id}`, data)
          .then((res) => {
            commit('updateSuccess', res.data.data)
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    updateHHMember({ commit, state }, data) {
      commit('updateHHMember', data)
    },

    removeHHMember({ commit, state }, index) {
      commit('removeHHMember', index)
    },

    addHHMember({ commit, state }) {
      commit('addHHMember')
    },

    resetMemberSignature({ commit, state }, data) {
      commit('resetMemberSignature', data)
    },

    addDocument({commit}, payload) {
        commit('addDocument', payload.document);
    },

    markComplete({commit, state, dispatch}, payload) {
      return axios.put(`/api/hope/applications/${state.application.id}/mark-complete`);
    },

    updateStatus({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/hope/application/${data.id}/status`, data).then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e)
        })
      });
    },

    updateProxy({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/hope/application/${data.id}/proxy`, data).then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e)
        })
      });
    },

    updateEvictionStatus({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/hope/application/${data.id}/eviction-status`, data).then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e)
        })
      });
    },

    createProject({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/hope/property`, data).then(res => {
          resolve(res)
        }).catch(e => {
          reject(e)
        })
      });
    },

    removeDocument({ commit, state }, deletedDocument) {
        let docs = [];

        _.each(state.documents, document => {
          if(document.id !== deletedDocument.id) {
            docs.push(document);
          }
        });

        commit('setDocuments', docs);
    },

    fetchVendorList ({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/hope/application/${id}/vendor-list`)
          .then((res) => {
            commit('fetchVendorListSuccess', res.data)
            resolve(res.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    switchType({ commit }, {id, type}) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/hope/application/${id}/switch-type/${type}`).then(res => {
          resolve(res)
        }).catch(e => {
          reject(e)
        })
      });
    },
  },
  getters: {
    payeeOrganization(state) {
      if(!state.project) {
        return null;
      }
      if(state.ownerOrganization && parseInt(state.project.payee_organization_id) == parseInt(state.ownerOrganization.id)) {
        return state.ownerOrganization;
      }

      if(state.managerOrganization && parseInt(state.project.payee_organization_id) == parseInt(state.managerOrganization.id)) {
        return state.managerOrganization;
      }
    },
    assets(state) {
      return state.assets
    },
    application(state) {
      return state.application
    },
    applicant(state) {
      return state.applicant
    },
    hhMembers(state) {
      return state.hhMembers
    },
    renterOwner(state) {
      return state.renterOwner
    },
    renterManager(state) {
      return state.renterManager
    },
    organization(state) {
      return state.organization
    },
    documentRequests(state) {
      return state.documentRequests;
    },
    statuses(state) {
      return state.statuses;
    },
    headOfHousehold(state) {
      return state.application.household.hoh;
    },
    program(state) {
      return state.application? state.application.program : {}
    },
    programSettings: state => state.application.program.settings,
    defaultProject: state => state.defaultProject,

    steps: (state) => ($lang) => {
      let stepResolver = new ApplicationStepResolver($lang, state.application);
      let steps = [];
      if(state.application && state.application.program) {
        if(!state.application.program.pages || state.application.program.pages.length === 0) {
          steps = stepResolver.defaultPages();
        }else {
          steps = stepResolver.fromPages(state.application.program.pages);
        }
      }

      if(state.lastStep && steps.length > state.lastStep) {
        return steps.slice(0, state.lastStep);
      }

      return steps;
    }
  },
}
